export function setMotionLayer(el: Element | null, on: boolean) {
  if (!el) return;
  if (!(el instanceof HTMLElement) && !(el instanceof SVGElement)) return;
  el.style.willChange = on ? "transform" : "";
}

export function setMotionLayers(elements: (Element | null)[], on: boolean) {
  elements.forEach((el) => setMotionLayer(el, on));
}
